module.exports = __webpack_public_path__ + "h5/img/logo4.a9b7874a.png";